<template>
    <div class="container1">
        <div class="container2">
            <img class="img" src="@/assets/images/loading-97.gif">
        </div>
    </div>
</template>
<script>
    export default{
        name:"Loading",
    }
</script>
<style>
    .container1{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        background-color: white;
        position: absolute;
        z-index: 100;
    }
    .container2{
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        position: absolute!important;
    }
    .img{
        max-height: 100%;
        max-width: 100%;
    }
</style>